import { defineComponent, ref, VNodeRef, watch, toRaw } from 'vue';
import { SelectableData } from '../csv-input/selectable-data';
import { MassSelectFormField } from './mass-select-form-field';

import CsvInput from '../csv-input/csv-input.vue';
import { isElementOrChidOf } from '../../../../platform/core/element-extensions';

export default defineComponent({
	components: {
		CsvInput,
	},
	props: {
		modelValue: MassSelectFormField,
		selectableData: Array<SelectableData>,
		separator: String,
		placeholder: String,
	},
	emits: ['editorBlurred', 'allSelected'],
	setup: (props, context) => {
		const container = ref<HTMLElement>();

		const onFocusOut = (e: FocusEvent): void => {
			if (container.value && !isElementOrChidOf(container.value, e.relatedTarget)) {
				context.emit('editorBlurred');
			}
		};

		let prevAllSelected = false;
		watch(props, () => {
			const model = toRaw(props.modelValue);
			const allSelected = model?.allSelected.value ?? false;
			const allSelectedChanged = prevAllSelected !== allSelected;

			if (allSelectedChanged && allSelected) {
				context.emit('allSelected');
			}

			prevAllSelected = allSelected;
		});

		return {
			onFocusOut,
			templateRefContainer: (el: VNodeRef | undefined): void => {
				container.value = el as HTMLElement | undefined;
			},
		};
	},
});
